<template>
  <div id="pers-tab6" name="hrms32e-tab6" class="content-pers-table">
    <hrms-table :columns="detail6Table"
                :data="detail"
                :maxRowspan="maxRowspanDetail6"
                :addInlineEventBool="validateStaappr"
                :editInlineEventBool="validateStaappr"
                :deleteInlineEventBool="validateStaappr"
                :deleteInlineBtnDisp="false"
                :saveInlineBtnDisp="validateStaappr"
                :saveInlineEvent="callSave"
                :nowLang="nowLang" />

    <div class="col-md-12 box-footer">
      <button type="button" class="btn bg-dark-gray pull-left" @click="togglePage(0)" value="Back"><i class="fa fa-chevron-circle-left"></i>{{ labelsButton['back'] }}</button>
    </div>

  </div>
</template>

<script>
import detailTemplate from 'components/hrms32e/detailTemplate'

export default {
  name: 'hrms32e-tab6',
  watch: {
    detail () {
      this.$nextTick(() => {
        this.errors.clear()
      })
    }
  },
  methods: {
    callSave (dataRowsHasFlg) {
      this.$validator.validateAll().then(result => {
        if (result && this.searchDetail.codempid_query !== '') {
          let param = {
            p_codempid: this.indexSelected.codempid,
            p_dtereq: this.searchDetail.dtereq,
            p_numseq: this.indexSelected.numseq,
            p_codempid_query: this.searchDetail.codempid_query
          }
          for (var i = 0; i < dataRowsHasFlg.length; i++) {
            dataRowsHasFlg[i] = Object.assign(dataRowsHasFlg[i], param)
          }
          this.postDetail6Save({ saveParams: dataRowsHasFlg, searchIndex: this.searchIndex, togglePage: this.togglePage })
        }
      })
    }
  },
  props: [ 'nowLang', 'labels', 'detail', 'pcDisp', 'togglePage', 'labelsButton', 'deleteTrainingData', 'detail6Table', 'maxRowspanDetail6', 'postDetail6Save', 'indexSelected', 'searchDetail', 'searchIndex', 'validateStaappr' ],
  components: {
    detailTemplate
  }
}
</script>



// WEBPACK FOOTER //
// tab6.vue?1da1d7e6